<template>
  <div ref="particlesContainer" class="tsparticles"></div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, onMounted, ref } from 'vue';
import type { ISourceOptions } from '@tsparticles/engine';
import { tsParticles } from '@tsparticles/engine';
import { loadFull } from 'tsparticles';

export default defineComponent({
  name: 'particle-canvas',
  props: {
    config: {
      type: Object as PropType<ISourceOptions>,
      required: true
    }
  },
  setup(props) {
    const particlesContainer = ref<HTMLElement | null>(null);

    const loadParticles = async (options: ISourceOptions) => {
      await loadFull(tsParticles);
      if (particlesContainer.value instanceof HTMLElement) {
        await tsParticles.load({ element: particlesContainer.value, options });
      }
    };

    onMounted(async () => {
      await loadParticles(props.config);
    });

    return {
      particlesContainer
    };
  }
});
</script>

<style lang="scss">
.tsparticles {
  opacity: 0;
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-timing-function: ease;

  .site--iframe.site--popover-active.site--mobile & {
    display: none;
  }
}
.tsparticles {
  &__in-section,
  &__in-flowpage {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 20;
    pointer-events: none;
  }
}
</style>
